$ = require 'jquery'

class Auth
  logged: ->
    text = $('#aspnetForm > table td:eq(1)').text()
    logged = /Ваш логин/.test(text)

    console.log 'auth.logged()', logged

    logged

  username: ->
    text = $('#aspnetForm > table td:eq(1)').text()
    match = text.match /Ваш логин ([\S]+)/

    username = false
    if match and match[1]
      username = match[1]

    console.log 'auth.username()', username

    if username == false
      throw new Error('Попытка получить имя пользователя провалилась. Вероятно, пользователь не аутентифицирован.')

    username

module.exports = new Auth